/*
HELPERS
*/

// import {ApiResponse} from "../classes/api/class.api.response";

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.getElementById('csrf-token').getAttribute('content');

export const callAPI = function(endpoint, data, method = 'get') {
    return new window.Promise((resolve, reject) => {
        if(window.localStorage.getItem('xpayrience_token_id') === null)
        {
            reject('Token ID is missing');
            return;
        }

        if(window.localStorage.getItem('xpayrience_access_token') === null)
        {
            reject('Access token is missing');
            return;
        }

        let header_xpayrience_sessionid = '';

        if(window.localStorage.getItem('x-xpayrience-sessionid'))
        {
            header_xpayrience_sessionid = window.localStorage.getItem('x-xpayrience-sessionid');
        }

        let token_id = window.localStorage.getItem('xpayrience_token_id');
        let access_token = window.localStorage.getItem('xpayrience_access_token');

        method = method.toLowerCase();

        let methods = [ 'delete', 'get', 'put', 'post' ];

        if(!methods.includes(method))
        {
            reject(Lang.get('errors.invalid-api-method-provided'));
            return;
        }

        let axiosInstance = axios.create({
            headers: {
                'Authorization': 'Bearer ' + access_token,
                'x-xpayrience-token-id': token_id,
                'x-xpayrience-sessionid': header_xpayrience_sessionid,
            }
        });
        /*
        console.log({
            headers: {
                'Authorization': 'Bearer ' + access_token,
                'x-xpayrience-token-id': token_id,
                'x-xpayrience-sessionid': header_xpayrience_sessionid,
            }
        });
        */
        axiosInstance[method](endpoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });

    });
}

export const countElements = function(obj) {
    let count = 0;
    for (let k in obj) if (obj.hasOwnProperty(k)) count++;
    return count;
}

export const empty = function(my_var) {
    if(!isset(my_var)) {
        return true;
    }

    my_var = my_var.replaceAll(' ', '')
        .replaceAll("\n", "")
        .replaceAll("\r", "");

    return my_var === '';
}

export const formatCurrency = function(number, strip_currency_name = true) {
    let formatter = new Intl.NumberFormat('fr-CA', {
        style: 'currency',
        currency: 'CAD',
        // minimumFractionDigits: 0,
        // maximumFractionDigits: 0,
    });

    let amount = formatter.format(number);

    if(strip_currency_name === true)
    {
        amount = amount.replace(' CA', '');
    }

    return amount;
}

export const formatTimeStamp = function(unix_timestamp,locale = 'fr',format = {day: "numeric", month: "long", year: "numeric", hour: "numeric", minute: "numeric", }) {

    let date = new Date(parseInt(unix_timestamp));

    if(locale === 'fr') {
        date = date.toLocaleString('fr-FR', format);
    }
    else if(locale === 'en') {
        date = date.toLocaleString('en-US', format);
    }

    return date;

}

export const isset = function(myvar) {
    return !(typeof myvar === 'undefined' || myvar === null);
}

export const roundAmount = function(amount) {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
}

export const roundCents = function(amount) {
    let round_floor = Math.floor(amount / 0.05) * 0.05;
    let round_ceil = Math.ceil(amount / 0.05) * 0.05;
    let diff_floor = amount - round_floor;
    let diff_ceil = round_ceil - amount;

    if(diff_floor < diff_ceil)
    {
        return round_floor;
    }

    return round_ceil;
}

export const setApiLocale = function(locale) {
    return new window.Promise((resolve, reject) => {
        callAPI(route('api.kiosk.set-locale'), { locale: locale }, 'put')
            .then(response => {
                // TODO: validate response
                resolve();
            })
            .catch(error => {
                console.log(error);
                reject(error);
            });
    });
}

export const generateOperatorUID = function(u) {

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });

}

